export const fonts = {
    main: 'Manrope, sans-serif'
};
